/**
 * @generated SignedSource<<8090d5349b7c4873602138486eeaa4bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandLogoGetUploadUrlInput = {
  clientMutationId?: string | null | undefined;
  fileName: string;
};
export type LogoGetUrlMutation$variables = {
  input: BrandLogoGetUploadUrlInput;
};
export type LogoGetUrlMutation$data = {
  readonly brandLogoGetUploadUrl: {
    readonly fileName: string;
    readonly url: string;
  } | null | undefined;
};
export type LogoGetUrlMutation = {
  response: LogoGetUrlMutation$data;
  variables: LogoGetUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandLogoGetUploadUrlPayload",
    "kind": "LinkedField",
    "name": "brandLogoGetUploadUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoGetUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogoGetUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c0428c2fe9e95095a7902579a2872dae",
    "id": null,
    "metadata": {},
    "name": "LogoGetUrlMutation",
    "operationKind": "mutation",
    "text": "mutation LogoGetUrlMutation(\n  $input: BrandLogoGetUploadUrlInput!\n) {\n  brandLogoGetUploadUrl(input: $input) {\n    url\n    fileName\n  }\n}\n"
  }
};
})();

(node as any).hash = "9473d047ff894fa1e8dc91be2f4e3679";

export default node;
